import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import ItemListComponent from "components/Item/list"
import { deleteItem, exportItems, getItems } from "store/item/item-action"
import { getAllItemCategories } from "store/general-renders/general-action"

const ItemList = () => {
  document.title = "Items"

  const dispatch = useDispatch()
  const { data, error, loading, exportStatus } = useSelector(
    state => state.item
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [item, setItem] = useState(null)
  const [filter, setFilter] = useState({})
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  // get item categories data
  const { itemCategories, itemCategoryLoading, itemCategoryError } =
    useSelector(state => ({
      itemCategories: state.generalRenders.itemCategories,
      itemCategoryLoading: state.generalRenders.itemCategoryLoading,
      itemCategoryError: state.generalRenders.itemCategoryError,
    }))

  // Handle item deletion and close the delete modal
  const handleDeleteFunc = data => {
    if (item) {
      dispatch(deleteItem(item.id)) // Dispatch delete action for the selected item
    }
    setDeleteModal(false) // Close the delete modal
  }

  // Set the item to be deleted and open the delete modal
  const onClickDelete = data => {
    setItem(data) // Store the selected item for deletion
    setDeleteModal(true) // Open the delete confirmation modal
  }

  // Fetches new items when a page number is clicked
  const onPageClick = link => {
    dispatch(getItems(link.url, pageNumber, according, search, filter))
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = values => {
    setFilter(values)
    dispatch(getItems(undefined, pageNumber, according, search, values))
  }
  // render items based search
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getItems(undefined, undefined, undefined, search, filter))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  // render items and item categories at first
  useEffect(() => {
    dispatch(getItems(undefined, pageNumber, according, search, filter))
    dispatch(getAllItemCategories())
  }, [pageNumber, according])

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportItems(search, filter))
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Items"} />
      <ItemListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        exportStatus={exportStatus}
        onExportBtnClick={onExportBtnClick}
        itemCategories={itemCategories}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
      />
    </React.Fragment>
  )
}

export default ItemList
